import { useState } from 'react';

import { Button } from '@components/button';
import { Checkbox } from '@components/checkbox';
import { IconTrash } from '@components/icons/trash';
import { List } from '@components/integrations/integrations-types';
import { hideModal, Modal, useModal } from '@components/modal';
import { Separator } from '@components/separator';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { useScopedTranslate } from '@locale/translate';

import { useDeleteList } from 'api/lists/hooks';

export const useDeleteListModal = () => useModal(DeleteList);

export const DeleteList = ({ list }: { list: List }) => {
  const { t } = useScopedTranslate(locale);
  const [confirm, setConfirm] = useState(false);

  const onSuccess = async () => {
    hideModal();
  };
  const deleteMutation = useDeleteList({
    onSuccess,
  });

  return (
    <Modal>
      <Modal.SimpleHeader title={t('deleteJourney')} />
      <Modal.Content>
        <Stack space={6}>
          <Stack>
            <Text text={t('areYouSure', list.name)} />
            <Text color="elementRed100" text={t('cannotBeUndone')} />
          </Stack>
          <Separator />
          <Stack space={4}>
            <Text font="semibold14" text={t('pleaseConfirm')} />
            <Checkbox
              dataCy="confirm-delete-list"
              label={t('iUnderstand')}
              onChange={(value) => setConfirm(value)}
            />
          </Stack>
          <Stack orientation="horizontal" space={4} justify="flex-end">
            <Button variant="secondary" onClick={hideModal} text={t('core.cancel')} />
            <Button
              data-cy="delete-journey"
              isDisabled={!confirm}
              onClick={() => deleteMutation.mutate(list.shortId)}
              disabled={deleteMutation.isLoading}
              variant="primary-red"
              iconLeft={<IconTrash />}
              text={t('core.delete')}
            />
          </Stack>
        </Stack>
      </Modal.Content>
    </Modal>
  );
};

export const locale = {
  en: {
    deleteJourney: 'Delete list',
    areYouSure: 'Are you sure you want to delete the list {0}?',
    cannotBeUndone: 'This can not be undone.',
    pleaseConfirm: 'Please confirm',
    iUnderstand: 'I understand',
  },
};
